<template>
  <el-container class="crm-shell">
    <el-aside class="crm-sidebar" width="214px">
      <div class="crm-logo">法多邦 <span>CRM</span></div>
      <el-menu :default-active="$route.path" router background-color="#13243e" text-color="#d1ddef" active-text-color="#fff">
        <el-menu-item v-for="page in visiblePages" :key="page.path" :index="page.path">{{ page.title }}</el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="crm-header"><strong>{{ currentTitle }}</strong><div><span>{{ employeeName }}</span><el-button type="text" @click="logout">退出登录</el-button></div></el-header>
      <el-main class="crm-main"><router-view /></el-main>
    </el-container>
  </el-container>
</template>

<script>
import { crmPages } from "./pages";
import { hasPermission } from "../utils/permission";

export default {
  name: "CrmShell",
  computed: {
    visiblePages() { return crmPages.filter((page) => hasPermission(page.permission)); },
    currentTitle() { return (crmPages.find((page) => page.path === this.$route.path) || {}).title || "电销管理系统"; },
    employeeName() { return this.$store.getters.GET_TITLE || "员工"; },
  },
  methods: {
    logout() {
      ["token", "spbs", "title", "quanxian", "userInfo"].forEach((key) => sessionStorage.removeItem(key));
      this.$store.commit("INIT_TOKEN", "");
      this.$router.replace("/login");
    },
  },
};
</script>

<style scoped>
.crm-shell { min-height: 100vh; }
.crm-sidebar { background: #13243e; min-height: 100vh; }
.crm-logo { height: 64px; display: flex; align-items: center; justify-content: center; color: white; font-size: 20px; font-weight: 700; }
.crm-logo span { margin-left: 7px; color: #65a7ff; }
.crm-sidebar .el-menu { border: 0; }
.crm-sidebar .el-menu-item.is-active { background: #226ee3 !important; }
.crm-header { display: flex; align-items: center; justify-content: space-between; border-bottom: 1px solid #e8edf5; background: white; }
.crm-header > div { display: flex; align-items: center; gap: 20px; color: #63738b; }
.crm-main { background: #f3f6fa; min-width: 0; }
@media (max-width: 800px) { .crm-sidebar { width: 148px !important; } .crm-logo { font-size: 16px; } .crm-main { padding: 10px; } }
</style>
